import API from './axios';

const endPoint = `api/bshop`;

export default class BshopService {
  
  static GetBshop(formData = {}) {
    const {
      bshop_id = '',
      bshop_name = '',      
      bshop_status = '',
    } = formData;
  
    const params = {
      bshop_id,
      bshop_name,
      bshop_status,
    };

    return API.post(`${endPoint}/getBshop`, params);
  };

  static FindBshop(formData = {}) {
    const {
      bshop_id = '',
      bshop_name = '',      
      bshop_status = '',
    } = formData;
  
    const params = {
      bshop_id,
      bshop_name,
      bshop_status,
    };

    return API.post(`${endPoint}/findBshop`, params);
  };

  static GetCity(formData = {}) {
    const {
      bshop_id = '',
      bshop_name = '',      
      bshop_status = '',
    } = formData;
  
    const params = {
      bshop_id,
      bshop_name,
      bshop_status,
    };

    return API.post(`${endPoint}/getCity`, params);
  };
  
}